import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginSuccess: null,
    changeNetwork: true,
    $userInfo: null,
  },
  getters: {},
  mutations: {
    setLoginSuccess(state, loginSuccess) {
      state.loginSuccess = loginSuccess;
    },
    setUserInfo(state, userInfo) {
      state.$userInfo = userInfo;
    },
  },
  actions: {},
  modules: {},
});
